'use strict';

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _shared = require('./shared');

var _SvgImage = require('../components/SvgImage');

var _SvgImage2 = _interopRequireDefault(_SvgImage);

var _BoundingBox = require('../components/BoundingBox');

var _BoundingBox2 = _interopRequireDefault(_BoundingBox);

var _LabelList = require('../components/LabelList');

var _LabelList2 = _interopRequireDefault(_LabelList);

var _LabelDropdown = require('../components/LabelDropdown');

var _LabelDropdown2 = _interopRequireDefault(_LabelDropdown);

var _Toolbar = require('../components/Toolbar');

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    heading: {
      display: 'flex',
      textAlign: 'left'
    },
    shortcuts: {
      display: 'block',
      width: '100%',
      outline: 0
    },
    box: {
      cursor: 'pointer'
    },
    boxInactive: {
      pointerEvents: 'none'
    },
    boxCurrent: {
      zIndex: 1000
    }
  };
};

var ImageManual = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(ImageManual, _React$Component);

  function ImageManual() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageManual);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageManual.__proto__ || Object.getPrototypeOf(ImageManual)).call.apply(_ref, [this].concat(args))), _this), _this.keymap = 'IMAGE', _this.state = {
      label: '',
      mode: 'rect',
      spans: [],
      origSpans: [],
      current: [],
      drawing: false,
      selected: null,
      pixel: 1
    }, _this.componentDidMount = function () {
      var _this$props = _this.props,
          content = _this$props.content,
          config = _this$props.config;

      _this.updateBoxes(content);

      if (config.labels && config.labels.length) {
        _this.setState({
          label: config.labels[0]
        });
      }
    }, _this.componentDidUpdate = function (prev) {
      var content = _this.props.content;

      if (prev.content && prev.content[_constants.TASK_ID] != content[_constants.TASK_ID]) {
        _this.updateBoxes(content);
      }
    }, _this.handleSizeUpdate = function (width, height, strokeWidth, fontSize, pixel) {
      _this.props.update({
        width: width,
        height: height
      });

      _this.setState({
        strokeWidth: strokeWidth,
        fontSize: fontSize,
        pixel: pixel
      });
    }, _this.updateBoxes = function (_ref2) {
      var _ref2$spans = _ref2.spans,
          spans = _ref2$spans === undefined ? [] : _ref2$spans;
      var newSpans = spans.map(function (span, i) {
        return _extends({}, span, {
          color: span.color || (0, _util.getColor)(_constants.BOX_COLORS, i),
          id: span.id || (0, _v2["default"])()
        });
      });

      _this.setState({
        origSpans: newSpans,
        spans: newSpans,
        current: [],
        drawing: false,
        selected: null
      });
    }, _this.updateShape = function (x, y) {
      var _this$state = _this.state,
          current = _this$state.current,
          mode = _this$state.mode;
      if (x === null || y === null) return;

      if (mode == 'polygon' || !current.length) {
        _this.setState({
          x: x,
          y: y,
          current: [].concat(_toConsumableArray(current), [[x, y]]),
          selected: null
        });
      } else {
        if (current.length == 1 && current[0][0] == x && current[0][1] == y) {
          _this.setState({
            x: x,
            y: y
          });

          return; // the second point is identical to the first one
        }

        var newCurrent = (0, _util.getRect)(current[0], [x, y]);

        _this.setState({
          x: x,
          y: y,
          current: newCurrent,
          selected: null
        }, function () {
          return _this.handleClose();
        });
      }
    }, _this.getCurrentPoints = function () {
      var _this$state2 = _this.state,
          mode = _this$state2.mode,
          current = _this$state2.current,
          x = _this$state2.x,
          y = _this$state2.y;
      if (!current.length) return [];
      if (mode === 'polygon') return [].concat(_toConsumableArray(current), [[x, y]]);
      return (0, _util.getRect)(current[0], [x, y]);
    }, _this.handleClick = function (pt) {
      var _this$state3 = _this.state,
          current = _this$state3.current,
          mode = _this$state3.mode;

      if (mode === 'rect' && current.length == 1 && current[0][0] == pt.x && current[0][1] == pt.y) {
        return; // the second point is identical to the first one
      }

      _this.setState({
        x: null,
        y: null,
        selected: null,
        drawing: true
      }, function () {
        return _this.updateShape((0, _util.roundPx)(pt.x), (0, _util.roundPx)(pt.y));
      });
    }, _this.handleMouseMove = function (pt) {
      _this.setState({
        x: pt.x,
        y: pt.y,
        drawing: true
      });
    }, _this.handleClose = function () {
      var _this$state4 = _this.state,
          spans = _this$state4.spans,
          label = _this$state4.label,
          current = _this$state4.current,
          mode = _this$state4.mode;

      if (mode === 'polygon' && current.length < 3 || mode === 'rect' && current.length != 4) {
        _this.setState({
          selected: null,
          current: [],
          drawing: false
        });

        return;
      }

      var id = (0, _v2["default"])();
      var color = (0, _util.getColor)(_constants.BOX_COLORS, spans.length);
      var newSpans = [].concat(_toConsumableArray(spans), [{
        id: id,
        label: label,
        points: current,
        color: color
      }]);

      _this.setState({
        current: [],
        spans: newSpans,
        selected: null,
        drawing: false,
        x: null,
        y: null
      });

      _this.props.update({
        spans: newSpans
      });
    }, _this.handleLabelSelect = function (label) {
      var _this$state5 = _this.state,
          selected = _this$state5.selected,
          spans = _this$state5.spans;

      _this.setState({
        label: label
      });

      if (selected) {
        var prevSpans = spans.filter(function (span) {
          return span.id != selected;
        });

        var newSpan = _extends({}, spans.find(function (span) {
          return span.id == selected;
        }), {
          label: label
        });

        var newSpans = [].concat(_toConsumableArray(prevSpans), [newSpan]);

        _this.setState({
          spans: newSpans
        });

        _this.props.update({
          spans: newSpans
        });
      }
    }, _this.handleSelect = function (id, label, event) {
      if (event.target.tagName !== 'circle') {
        var selected = _this.state.selected === id ? null : id;

        _this.setState({
          label: label,
          selected: selected
        });
      }
    }, _this.handleDelete = function () {
      var _this$state6 = _this.state,
          selected = _this$state6.selected,
          spans = _this$state6.spans;
      var newSpans = spans.filter(function (_ref3) {
        var id = _ref3.id;
        return id != selected;
      });

      _this.setState({
        selected: null,
        current: [],
        drawing: false,
        spans: newSpans
      });

      _this.props.update({
        spans: newSpans
      });
    }, _this.handleReset = function () {
      var newSpans = _this.state.origSpans;

      _this.setState({
        spans: newSpans,
        selected: null
      });

      _this.props.update({
        spans: newSpans
      });
    }, _this.handleResize = function (i) {
      var _this$state7 = _this.state,
          mode = _this$state7.mode,
          selected = _this$state7.selected,
          spans = _this$state7.spans;
      var current = spans.find(function (span) {
        return span.id == selected;
      });
      var prevSpans = spans.filter(function (span) {
        return span.id != selected;
      });

      if (mode === 'rect') {
        var opposites = {
          0: 2,
          1: 3,
          2: 0,
          3: 1
        };
        var opp = opposites[i];

        var _current$points$i = _slicedToArray(current.points[i], 2),
            x = _current$points$i[0],
            y = _current$points$i[1];

        var points = [current.points[opp]];

        _this.setState({
          drawing: true,
          current: points,
          spans: prevSpans,
          x: x,
          y: y
        });
      }
    }, _this.handleMove = function (dir) {
      var _this$state8 = _this.state,
          selected = _this$state8.selected,
          spans = _this$state8.spans,
          pixel = _this$state8.pixel;
      if (!selected) return;
      var prevSpans = spans.filter(function (span) {
        return span.id != selected;
      });

      var current = _extends({}, spans.find(function (span) {
        return span.id == selected;
      }));

      var newSpans = [].concat(_toConsumableArray(spans));
      var newPoints = [].concat(_toConsumableArray(current.points));
      if (dir === 'left') newPoints = newPoints.map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            x = _ref5[0],
            y = _ref5[1];

        return [x - pixel, y];
      });else if (dir === 'right') newPoints = newPoints.map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            x = _ref7[0],
            y = _ref7[1];

        return [x + pixel, y];
      });else if (dir === 'up') newPoints = newPoints.map(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
            x = _ref9[0],
            y = _ref9[1];

        return [x, y - pixel];
      });else if (dir === 'down') newPoints = newPoints.map(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
            x = _ref11[0],
            y = _ref11[1];

        return [x, y + pixel];
      });
      newSpans = [].concat(_toConsumableArray(prevSpans), [_extends({}, current, {
        points: newPoints
      })]);

      _this.setState({
        spans: newSpans
      });

      _this.props.update({
        spans: newSpans
      });
    }, _this.handleShortcuts = function (action, ev) {
      switch (action) {
        case 'rect':
          _this.setState({
            mode: 'rect'
          });

          break;

        case 'polygon':
          _this.setState({
            mode: 'polygon'
          });

          break;

        case 'reset':
          _this.handleReset();

          break;

        case 'delete':
          _this.handleDelete();

          break;

        case 'exit':
          if (_this.state.drawing) _this.handleDelete();else _this.setState({
            selected: null
          });
          break;

        case 'left':
          _this.handleMove('left');

          break;

        case 'right':
          _this.handleMove('right');

          break;

        case 'up':
          _this.handleMove('up');

          break;

        case 'down':
          _this.handleMove('down');

          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageManual, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          ToolbarButton = _props.ToolbarButton,
          classes = _props.classes;
      var labels = config.labels,
          shadeBoxes = config.shadeBoxes,
          showCenter = config.showCenter,
          labelStyle = config.labelStyle,
          darkenImage = config.darkenImage,
          clickBoxes = config.clickBoxes;
      var modes = ['rect', 'polygon'];
      var _state = this.state,
          mode = _state.mode,
          drawing = _state.drawing,
          selected = _state.selected,
          label = _state.label,
          spans = _state.spans,
          current = _state.current,
          origSpans = _state.origSpans,
          strokeWidth = _state.strokeWidth,
          fontSize = _state.fontSize;
      var trapActive = mode === 'rect' && drawing;
      var mouseMoveAction = drawing ? this.handleMouseMove : null;
      var LabelComponent = labelStyle == 'dropdown' ? _LabelDropdown2["default"] : _LabelList2["default"];
      var boundingBoxProps = {
        shadeBoxes: shadeBoxes,
        showCenter: showCenter,
        strokeWidth: strokeWidth,
        fontSize: fontSize
      };
      var boxClassNames = (0, _classnames2["default"])(classes.box, _defineProperty({}, classes.boxInactive, this.state.drawing));
      var currentPoints = this.getCurrentPoints();

      var toolbar = _react2["default"].createElement(_util.ShortcutsWrapper, {
        ctx: this.context.shortcuts,
        className: classes.shortcuts,
        name: this.keymap,
        handler: this.handleShortcuts,
        targetNodeSelector: 'body',
        global: true
      }, _react2["default"].createElement(_Toolbar.Toolbar, null, _react2["default"].createElement('div', null, modes.map(function (m) {
        return _react2["default"].createElement(ToolbarButton, {
          key: m,
          id: m,
          active: mode == m,
          onClick: function onClick() {
            return _this2.setState({
              mode: m
            });
          },
          keyName: (0, _util.getKeyName)(_this2.context, _this2.keymap, m)
        });
      })), _react2["default"].createElement('div', null, _react2["default"].createElement(ToolbarButton, {
        id: 'delete',
        onClick: this.handleDelete,
        disabled: !selected,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'delete')
      }), _react2["default"].createElement(ToolbarButton, {
        id: 'reset',
        onClick: this.handleReset,
        disabled: !spans.length && !origSpans.length,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'reset')
      }))));

      return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_shared.Heading, {
        toolbar: toolbar,
        classes: {
          _root: classes.heading
        },
        hasLabels: true
      }, _react2["default"].createElement(LabelComponent, {
        labels: labels,
        selected: label,
        handleSelect: this.handleLabelSelect,
        keymap: config.labelKeymap
      })), _react2["default"].createElement(_shared.Content, null, _react2["default"].createElement(_SvgImage2["default"], {
        content: content,
        darkenImage: darkenImage,
        handleClick: this.handleClick,
        handleMouseMove: mouseMoveAction,
        renderSpans: false,
        trapActive: trapActive,
        onDoubleClick: mode === 'polygon' ? this.handleClose : null,
        onSizeUpdate: this.handleSizeUpdate,
        style: {
          cursor: 'crosshair'
        }
      }, spans.map(function (span, i) {
        return _react2["default"].createElement(_BoundingBox2["default"], _extends({
          key: span.id,
          i: i,
          id: span.id,
          onClick: !drawing ? function (event) {
            return _this2.handleSelect(span.id, span.label, event);
          } : null,
          selected: span.id == selected,
          points: span.points || [],
          center: span.center,
          color: span.color,
          label: span.label,
          classes: {
            _root: boxClassNames
          },
          style: {
            pointerEvents: drawing ? 'none' : null
          },
          autoPositionLabel: true,
          pathProps: !clickBoxes && span.id !== selected ? {
            fill: 'none'
          } : null
        }, boundingBoxProps));
      }), !!current.length && _react2["default"].createElement(_BoundingBox2["default"], _extends({
        key: 'current',
        i: -1,
        points: currentPoints,
        color: (0, _util.getColor)(_constants.BOX_COLORS, spans.length),
        classes: {
          _root: (0, _classnames2["default"])(boxClassNames, classes.boxCurrent)
        },
        pathProps: {
          style: {
            pointerEvents: mode === 'polygon' ? 'none' : null
          }
        },
        closePath: mode === 'polygon' ? false : true
      }, boundingBoxProps), mode == 'polygon' && _react2["default"].createElement(Points, {
        drawing: drawing,
        points: currentPoints,
        color: (0, _util.getColor)(_constants.BOX_COLORS, spans.length),
        handleClose: this.handleClose,
        handleSelectPoint: this.handleSelectPoint
      })))));
    }
  }]);

  return ImageManual;
}(_react2["default"].Component), _class2.id = 'image_manual', _class2.defaultProps = {
  ToolbarButton: _Toolbar.ToolbarButton,
  minStrokeWidth: 4,
  minFontSize: 16,
  centerLength: 10,
  iconSize: 24,
  activeColor: 'yellow',
  config: {}
}, _class2.contextTypes = {
  shortcuts: _propTypes2["default"].object
}, _temp2)) || _class);
exports["default"] = ImageManual;

var Points = function Points(_ref12) {
  var points = _ref12.points,
      handleClose = _ref12.handleClose,
      color = _ref12.color,
      drawing = _ref12.drawing;
  return points.map(function (_ref13, i) {
    var _ref14 = _slicedToArray(_ref13, 2),
        x = _ref14[0],
        y = _ref14[1];

    var isStart = i === 0;
    var clickable = drawing && i === points.length - 1;
    var onClickDrawing = isStart ? handleClose : null;
    var style = clickable ? {
      pointerEvents: 'none'
    } : null;
    return _react2["default"].createElement('circle', {
      key: i,
      cx: x,
      cy: y,
      r: 5,
      fill: color,
      onClick: drawing ? onClickDrawing : null,
      style: style,
      stroke: 'transparent',
      strokeWidth: 20
    });
  });
};